<template>
  <div class="full-size">
    <div v-if="tabName === 'Relatórios'">
      <Relatorios/>
    </div>
    <div v-if="tabName === 'Lista de E-mails'">
      <ListaEmails />
    </div>
    <div v-if="tabName === 'Etiquetas'">
      <Etiquetas />
    </div>
  </div>
</template>

<script>
import Relatorios from '../Relatorios/Relatorios'
import ListaEmails from '../ListaEmails/ListaEmails'
import Etiquetas from '../Etiquetas/Etiquetas'

export default {
  props: {
    tabName: {
      type: String,
      default: 'E-mail Áreas'
    }
  },
  components: {
    Etiquetas,
    ListaEmails,
    Relatorios
  }
}
</script>
